export const SamplePermissions = {
  "General Manager": [],
  "Asst. General Manager": [],
  Manager: [
    {
      path: "/sample/consumptions",
      label: "Consumptions",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/sors",
      label: "SOR",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Assistant Manager": [
    {
      path: "/sample/consumptions",
      label: "Consumptions",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/sors",
      label: "SOR",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Receptionist: [
    {
      path: "/sample/consumptions",
      label: "Consumptions",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/sors",
      label: "SOR",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
  ],

  "Store Assistant": [
    {
      path: "/sample/consumptions",
      label: "Consumptions",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/sors",
      label: "SOR",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Executive: [
    {
      path: "/sample/consumptions",
      label: "Consumptions",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/sors",
      label: "SOR",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Store Keeper": [
    {
      path: "/sample/consumptions",
      label: "Consumptions",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/sors",
      label: "SOR",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Sr. Executive": [],
};
